import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Returns the current trial status derived from the company subscription.
 *
 * isTrialActive  – true only while the trial window is open and not yet paid.
 * daysRemaining  – calendar days left; 0 once expired.
 * trialExpiryDate – raw ISO string from Firestore, or null.
 */
const useTrial = () => {
  const subscription = useSelector(
    (state) => state.auth?.profile?.subscription
  );

  return useMemo(() => {
    if (!subscription?.isTrialActive || !subscription?.trialExpiryDate) {
      return { isTrialActive: false, daysRemaining: 0, trialExpiryDate: null };
    }

    if (subscription?.subscriptionStatus === 'active') {
      return { isTrialActive: false, daysRemaining: 0, trialExpiryDate: null };
    }

    const daysRemaining = Math.ceil(
      (new Date(subscription.trialExpiryDate) - new Date()) /
        (1000 * 60 * 60 * 24)
    );

    if (daysRemaining <= 0) {
      return {
        isTrialActive: false,
        daysRemaining: 0,
        trialExpiryDate: subscription.trialExpiryDate,
      };
    }

    return {
      isTrialActive: true,
      daysRemaining,
      trialExpiryDate: subscription.trialExpiryDate,
    };
  }, [
    subscription?.isTrialActive,
    subscription?.trialExpiryDate,
    subscription?.subscriptionStatus,
  ]);
};

export default useTrial;
